import { BaseModal } from './base-modal'
import styles from './styles/modal-bottom.module.scss'
import { ModalWindowProps } from './types/modal.types'

export const ModalBottom = (props: ModalWindowProps) => {
  return (
    <BaseModal
      className={styles.modalWindowBottom}
      width="100vw"
      {...props}
    >
      {props.children}
    </BaseModal>
  )
}
